<template>
  <div class="-grid-cell-component">
    <div class="-grid-cell-component__textfield-container">
      <div class="sui-text-field">
        <input
          ref="localTxtFld"
          v-model="localMsgVal"
          placeholder="local"
          :type="'text'"
          :class="['sui-text-field__input']"
          :style="[mlngDtlList.length > 1 ? {'width':'45%'} : {'width':'95%'}]"
          :disabled="disabled"
          @change="setLocalMsgVal"
        >
        <template
          v-if="mlngDtlList.length > 1"
        >
          <div style="display:inline-flex;width:4px" />
          <input
            ref="globalTxtFld"
            v-model="globalMsgVal"
            placeholder="global"
            :type="'text'"
            :class="['sui-text-field__input']"
            style="width:45%"
            :disabled="disabled"
            @change="setGlobalMsgVal"
            @blur="onBlurGlobalTxtFld"
          >
          <div style="display:inline-flex;width:4px" />
          <button
            type="button"
            class="comm_btn_lang"
            :disabled="disabled"
            @click="onClickMlngPopupBtn"
          >
            {{ txtMlngTitle }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// 세션 사용 목적
import Vue from 'vue';
import store from '~system/vuex';

export default {
  name: 'CellMlngEditor',
  props: {
    // 컴포넌트를 사용하는 페이지ID
    pageId: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    // 다국어ID
    multiLanguageIdField: {
      type: String,
      required: false,
      default() {
        return 'multiLanguageId';
      },
    },
    // multiTenancy 여부
    multiTenancy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localMsgVal: '', // 로컬 텍스트 필드에 보여질 내용
      globalMsgVal: '', // Global 텍스트 필드에 보여질 내용
      // eslint-disable-next-line
      localLangId: store.getters.userInfo.langId, // 로컬 langId
      // eslint-disable-next-line
      globalLangId: store.getters.userInfo.globalLangId, // global langId
      txtMlngTitle: utils.getMessageById('MSG_TIT_MLNG_MGT'),
      msgClickGlobe: utils.getMessageById('MSG_ALT_CLICK_GLOBE'),

      placeholder: utils.getMessageById('MSG_ALT_CLICK_GLOBE'),
      multiLanguageId: '',
      // 다국어 object array
      mlngDtlList: [],
    };
  },
  methods: {
    // 로컬 메시지 값 변경 -> 모델 데이터 해당 값에 update
    setLocalMsgVal() {
      // Global 언어 가져오기
      if (!this.globalLangId || !utils.find(this.mlngDtlList, { langId: this.globalLangId })) {
        utils.messageBox('warning', utils.getMessageById('MSG_BTN_CFRM'), utils.getMessageById('MSG_ALT_NOT_EXIST_GLOBAL_LNG_INFO'));
        return;
      }
      const _localLang = utils.find(this.mlngDtlList, { langId: this.localLangId });
      _localLang.multiLanguageContent = this.localMsgVal;
      this.$emit('mlng-changed', utils.clone(this.mlngDtlList));
    },
    // 글로벌 메시지 값 변경 -> 모델 데이터 해당 값에 update
    setGlobalMsgVal() {
      // Global 언어 가져오기
      if (!this.globalLangId || !utils.find(this.mlngDtlList, { langId: this.globalLangId })) {
        utils.messageBox('warning', utils.getMessageById('MSG_BTN_CFRM'), utils.getMessageById('MSG_ALT_NOT_EXIST_GLOBAL_LNG_INFO'));
        return;
      }
      const _globalLang = utils.find(this.mlngDtlList, { langId: this.globalLangId });
      _globalLang.multiLanguageContent = this.globalMsgVal;

      // 값이 없는 언어에 global 언어값 쓰기
      this.onClickBkApplyBtn();

      this.$emit('mlng-changed', utils.clone(this.mlngDtlList));
    },
    /**
     * global textField blur event handler
     * global 언어값이 바뀔 때 값이 없는 언어에 global 언어값 쓰기
     * @function onBlurGlobalTxtFld
     * @param {None}
     * @returns {None}
     */
    onBlurGlobalTxtFld() {
      // 값이 없는 언어에 global 언어값 쓰기
      this.onClickBkApplyBtn();
    },
    /**
     * 다국어 팝업 버튼 click event handler
     * 다국어 입력 팝업 호출
     * @function onClickMlngPopupBtn
     * @returns {None}
     */
    onClickMlngPopupBtn() {
      if (!this.localLangId || utils.isEmpty(this.localLangId)) {
        utils.messageBox('information', utils.getMessageById('MSG_ALT_NO_LOCAL_LNG_INFO'));
      } else {
        utils.openLayerPopup('PGE_CMZ_00018', this.mlngPopupConfirmed, {
          pageInitialData: {
            localLangId: this.localLangId,
            globalLangId: this.globalLangId,
            mlngMsg: this.mlngDtlList,
            disabled: this.disabled,
            readonly: this.readonly,
          },
          size: 'lg',
        });
      }
    },
    /**
     * 다국어 입력 팝업 callback
     * mlng-changed 이벤트 발생(변경유무 관련없이 창만 닫으면 발생)
     * @function mlngPopupConfirmed
     * @param {Array}
     * @returns {Object}
     */
    mlngPopupConfirmed(arrMlng) {
      if (!utils.isEmpty(arrMlng)) {
        this.mlngDtlList = arrMlng;
        // 입력 textField 에 표시되는 local, global 값 갱신
        this.updateInputBoxVals();
        this.$emit('mlng-changed', utils.clone(this.mlngDtlList));
      }
    },

    /**
     * 언어 마스터 정보 가져와서 다국어 배열 셋팅하기
     * @function getLangMaster
     * @param {None}
     * @returns {Promise}
     */
    getLangMaster() {
      const that = this;

      return new Promise((resolve, reject) => {
        http.request(that.pageId, 'DTS_CMZ_00039', {
        }).then(res => {
          that.mlngDtlList = [];

          res.data.forEach(itm => {
            that.mlngDtlList.push({
              multiLanguageId: that.multiLanguageId,
              langId: itm.langId,
              langName: itm.langName,
              multiLanguageContent: '',
              multiLanguageAbbreviationContent: '',
              multiLanguageTypeCode: '',
            });
          });

          resolve(that.mlngDtlList);
        }).catch(err => {
          console.error(err);
          reject(err);
        });
      });
    },
    /**
     * 입력된 다국어ID에 해당하는 다국어 데이터 조회
     * @function getMlngListById
     * @param {String} mlngId : 다국어ID
     * @returns {Promise}
     */
    getMlngListById(mlngId) {
      const that = this;
      return new Promise((resolve, reject) => {
        http.request(that.pageId, 'DTS_CMZ_00023', {
          path: {
            'multi-languages-id': mlngId,
          },
          query: {
            tenantId: this.multiTenancy ? utils.getConfigurationValue('YML_TENANT_ID_DEFAULT') : '',
          },
        }).then(res => {
          // 새로 가져온 다국어 값만 다시 쓰기
          // 조회 결과가 모든 언어 갯수만큼 row를 가져오지 못할 경우 고려
          res.data.forEach(itm => {
            for (let i = 0; i < that.mlngDtlList.length; i += 1) {
              that.mlngDtlList[i].multiLanguageId = that.multiLanguageId;
              that.mlngDtlList[i].multiLanguageTypeCode = itm.multiLanguageTypeCode;

              if (that.mlngDtlList[i].langId === itm.langId) {
                that.mlngDtlList[i].multiLanguageContent = itm.multiLanguageContent;
                that.mlngDtlList[i].multiLanguageAbbreviationContent = itm.multiLanguageAbbreviationContent;
              }
            }
          });

          // 조회시 global 값이 없을 경우 local 값으로 보여주도록 수정
          if (this.globalLangId && utils.find(this.mlngDtlList, { langId: this.globalLangId })) {
            const globalLang = utils.find(this.mlngDtlList, { langId: this.globalLangId });
            const localLang = utils.find(this.mlngDtlList, { langId: this.localLangId });
            if (utils.isEmpty(globalLang.multiLanguageContent)) {
              globalLang.multiLanguageContent = localLang.multiLanguageContent;
              // 값이 없는 언어에 global 언어값 쓰기
              this.onClickBkApplyBtn();
            }
          }
          /*
          const globalLang = utils.find(this.mlngDtlList, { langId: this.globalLangId });
          const localLang = utils.find(this.mlngDtlList, { langId: this.localLangId });
          if (utils.isEmpty(globalLang.multiLanguageContent)) {
            globalLang.multiLanguageContent = localLang.multiLanguageContent;
            // 값이 없는 언어에 global 언어값 쓰기
            this.onClickBkApplyBtn();
          }
          */

          resolve(res);
        }).catch(err => {
          console.error(err);
          reject(err);
        });
      });
    },
    /**
     * 일괄적용버튼 click event handler
     * 다국어 값들 중 비어있는 값과 약어에 현재 Global 언어로 셋팅된 값을 일괄 복사
     * local 언어로 설정된 값은 복사대상이 아님
     * @function onClickBkApplyBtn
     * @param {None}
     * @returns {None}
     */
    onClickBkApplyBtn() {
      if (!this.globalLangId || !utils.find(this.mlngDtlList, { langId: this.globalLangId })) {
        utils.messageBox('warning', utils.getMessageById('MSG_BTN_CFRM'), utils.getMessageById('MSG_ALT_NOT_EXIST_GLOBAL_LNG_INFO'));
        return false;
      }
      // Global 언어 가져오기
      const globalLang = utils.find(this.mlngDtlList, { langId: this.globalLangId });
      utils.forEach(this.mlngDtlList, itm => {
        // 다국어 값이 비어있을 경우 global 약어 값으로 채움
        if (utils.isEmpty(itm.multiLanguageContent)) {
          itm.multiLanguageContent = globalLang.multiLanguageContent;
        }
        // 다국어 약어 값이 비어있을 경우 global 언어 약어 값으로 채움
        if(utils.isEmpty(itm.multiLanguageAbbreviationContent)) {
          itm.multiLanguageAbbreviationContent = globalLang.multiLanguageAbbreviationContent;
        }
      });
      return true;
    },
    /**
     * 입력 textField 에 표시되는 local, global 값 갱신
     * @function updateInputBoxVals
     * @param {None}
     * @returns {None}
     */
    updateInputBoxVals() {
      for (let i = 0; i < this.mlngDtlList.length; i += 1) {
        // local 다국어 메시지 값
        if (this.mlngDtlList[i].langId === this.localLangId) {
          this.localMsgVal = this.mlngDtlList[i].multiLanguageContent;
        }

        // global 다국어 메시지 값
        if (this.mlngDtlList[i].langId === this.globalLangId) {
          this.globalMsgVal = this.mlngDtlList[i].multiLanguageContent;
        }
      }
      this.$forceUpdate();
    },
    setValue(valueObj, dataRow, langMasterInfo) {
      this.multiLanguageId = dataRow[this.multiLanguageIdField];

      if (utils.isEmpty(valueObj) || valueObj.length === 0) {
        // 언어 마스터 정보 가져오기
        if (!langMasterInfo || langMasterInfo.length === 0) {
          this.getLangMaster().then(() => {
            // 다국어ID가 존재할 경우 해당 다국어 목록 가져오기
            if (!utils.isEmpty(this.multiLanguageId)) {
              this.getMlngListById(this.multiLanguageId).then(() => {
                this.updateInputBoxVals();
                this.$emit('service-queried', utils.clone(this.mlngDtlList));
              }).catch(err => {
                console.error(err);
              });
            } else {
              this.updateInputBoxVals();
              // TODO: dataset에 저장토록
              // this.$emit('mlng-changed', utils.clone(this.mlngDtlList));
            }
          }).catch(err => {
            console.error(err);
          });
        } else {
          this.mlngDtlList = langMasterInfo;
          // 다국어ID가 존재할 경우 해당 다국어 목록 가져오기
          if (!utils.isEmpty(this.multiLanguageId)) {
            this.getMlngListById(this.multiLanguageId).then(() => {
              this.updateInputBoxVals();
              this.$emit('service-queried', utils.clone(this.mlngDtlList));
            }).catch(err => {
              console.error(err);
            });
          } else {
            this.updateInputBoxVals();
            // TODO: dataset에 저장토록
            // this.$emit('mlng-changed', utils.clone(this.mlngDtlList));
          }
        }
      } else {
        this.mlngDtlList = valueObj;
        this.updateInputBoxVals();
      }
    },
    setFocus() {
      if (!this.disabled) {
        this.setFocusLocalTxtFld();
      }
    },
    setFocusLocalTxtFld() {
      if (!this.disabled) {
        this.$refs.localTxtFld.focus();
      }
    },
    setFocusGlobalTxtFld() {
      if (!this.globalLangId || !utils.find(this.mlngDtlList, { langId: this.globalLangId })) {
        utils.messageBox('warning', utils.getMessageById('MSG_BTN_CFRM'), utils.getMessageById('MSG_ALT_NOT_EXIST_GLOBAL_LNG_INFO'));
        return false;
      }
      if (!this.disabled) {
        this.$refs.globalTxtFld.focus();
      }
      return false;
    },
  },
};
</script>

<style scoped>
</style>
